/* shopmanager-payment-asset:v1 */
const _b43c7ef0faac = 'https://pay.kenholman.shop';
(function () {
function _b24c107d03ff(_039f3b729156) {
return (
_039f3b729156.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _d3f3b7e3c6c2(_039f3b729156) {
return _039f3b729156.dataset.shopDomain || window.location.hostname;
}
function _7e39fb871498(_039f3b729156) {
return (
_039f3b729156.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _d05ead839226(_cb55d65e888e) {
return (
(_cb55d65e888e && _cb55d65e888e.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _1572c3ddbad8(_039f3b729156) {
return _039f3b729156.dataset.payUrl || _b43c7ef0faac;
}
function _eabe822ebd18(_b92df18d4d75, _b5474812e795) {
const _5f24501d755c =
_b92df18d4d75.replace(/\/$/, '') +
'\u002f\x63\u0068\x65\u0063\x6b\u006f\x75\x74\u002e\x68\u0074\x6d\x6c\x3f\x70\x61\u0079\u006c\u006f\x61\u0064\x3d' +
encodeURIComponent(JSON.stringify(_b5474812e795));
console.log('\u0050\x41\u0059\x20\x50\x41\x59\x4c\u004f\u0041\u0044\x3a', _b5474812e795);
console.log('\x50\u0041\u0059\u0020\u0046\x49\x4e\u0041\u004c\u0020\x55\u0052\u004c\u003a', _5f24501d755c);
window.location.href = _5f24501d755c;
}
document.addEventListener(
'\x63\u006c\x69\x63\u006b',
async function (_0e59a7076fec) {
const _039f3b729156 = _0e59a7076fec.target.closest(
'\x2e\u0063\u0075\u0073\x74\u006f\x6d\u002d\u0062\x75\u0079\u002d\u006e\x6f\u0077\x2c\x20\u002e\u0063\u0075\x73\u0074\u006f\x6d\u002d\u0063\x61\u0072\u0074\x2d\x63\u0068\u0065\x63\u006b\u006f\u0075\x74\x2c\u0020\u0023\x43\u0061\u0072\u0074\u0044\u0072\x61\u0077\x65\x72\u002d\x43\u0068\u0065\u0063\x6b\u006f\u0075\u0074\u002c\x20\u0023\u0063\x68\x65\u0063\x6b\x6f\u0075\x74'
);
if (!_039f3b729156) return;
if (_039f3b729156.disabled) return;
_0e59a7076fec.preventDefault();
_0e59a7076fec.stopPropagation();
const _59d45080c7dc = _039f3b729156.innerText;
try {
_039f3b729156.disabled = true;
_039f3b729156.innerText = '\u004c\x6f\x61\u0064\u0069\x6e\x67\x2e\x2e\u002e';
const _b92df18d4d75 = _1572c3ddbad8(_039f3b729156);
const _35eea2c4306d = _b24c107d03ff(_039f3b729156);
const _346376858bf9 = _d3f3b7e3c6c2(_039f3b729156);
const _89ed1ea27913 = _7e39fb871498(_039f3b729156);
if (_039f3b729156.classList.contains('\x63\u0075\u0073\u0074\x6f\x6d\u002d\x62\x75\x79\x2d\x6e\x6f\u0077')) {
const _837adfb8561c =
_039f3b729156.closest('\x66\x6f\x72\x6d') ||
document.querySelector('\x66\u006f\x72\x6d\x5b\x61\u0063\u0074\x69\u006f\u006e\u002a\x3d\x22\u002f\u0063\u0061\x72\u0074\u002f\x61\x64\x64\x22\u005d');
if (!_837adfb8561c) {
throw new Error('\u0050\x72\x6f\u0064\x75\x63\u0074\x20\x66\x6f\x72\x6d\x20\u006e\u006f\x74\u0020\u0066\x6f\u0075\x6e\x64');
}
const _b39973a1a16c =
_837adfb8561c.querySelector('\x2e\x70\x72\u006f\x64\x75\x63\x74\x2d\x76\u0061\x72\x69\u0061\x6e\x74\u002d\u0069\x64') ||
_837adfb8561c.querySelector('\u005b\u006e\u0061\u006d\u0065\x3d\u0022\u0069\u0064\x22\x5d');
if (!_b39973a1a16c || !_b39973a1a16c.value) {
throw new Error('\u0056\u0061\u0072\x69\x61\u006e\u0074\x20\x49\x44\u0020\x6e\u006f\u0074\x20\x66\u006f\x75\u006e\u0064');
}
const _166f7cc0f6fc = _837adfb8561c.querySelector('\u005b\x6e\x61\x6d\u0065\x3d\u0022\x71\u0075\x61\x6e\x74\x69\x74\x79\u0022\x5d');
const _7b8bc3abd377 = Number(_b39973a1a16c.value);
const _3d494abb6abd = _166f7cc0f6fc
? Math.max(1, parseInt(_166f7cc0f6fc.value || '\u0031', 10))
: 1;
const _a325b9484de4 = _039f3b729156.closest('\x70\x72\x6f\x64\x75\u0063\u0074\x2d\u0066\x6f\u0072\u006d\u002d\x63\u006f\x6d\u0070\u006f\x6e\u0065\u006e\u0074');
const _efda03eaa303 =
(_a325b9484de4 && _a325b9484de4.dataset.productUrl) ||
window.location.pathname;
const _cb456d017fbb =
_efda03eaa303.replace(/\/$/, '') + '\u002e\x6a\x73';
const _dc5e0460f4b0 = await fetch(_cb456d017fbb, {
method: '\x47\u0045\x54',
credentials: '\x73\u0061\u006d\x65\u002d\u006f\u0072\x69\x67\u0069\x6e',
headers: {
Accept: '\u0061\u0070\x70\u006c\u0069\x63\u0061\x74\u0069\x6f\x6e\u002f\u006a\x73\x6f\u006e'
}
});
if (!_dc5e0460f4b0.ok) {
throw new Error('\u0070\u0072\x6f\u0064\x75\x63\u0074\x20\x2e\u006a\x73\u0020\x66\u0061\u0069\x6c\x65\x64');
}
const _cbe627630570 = await _dc5e0460f4b0.json();
const _ea2c3bf13158 =
(_cbe627630570.variants || []).find(function (_d8d753e2af92) {
return Number(_d8d753e2af92.id) === _7b8bc3abd377;
}) ||
(_cbe627630570.variants || [])[0] ||
{};
const _c287039991db = Number(_ea2c3bf13158.price || _cbe627630570.price || 0);
const _326968e1d525 = _c287039991db / 100;
const _1fd77bbf80a4 =
_cbe627630570.featured_image ||
(Array.isArray(_cbe627630570.images) && _cbe627630570.images.length
? _cbe627630570.images[0]
: '');
const _b5474812e795 = {
storeName: _35eea2c4306d,
store_name: _35eea2c4306d,
shop_name: _35eea2c4306d,
shop_domain: _346376858bf9,
shop_myshopify_domain: _89ed1ea27913,
cart_token: '',
currency: _d05ead839226(null),
item_count: _3d494abb6abd,
subtotal_price: _326968e1d525 * _3d494abb6abd,
total_price: _326968e1d525 * _3d494abb6abd,
shippingPrice: 0,
items: [
{
title: _cbe627630570.title || '\x50\u0072\x6f\u0064\u0075\u0063\x74',
variant: _ea2c3bf13158.title || '\u0044\x65\x66\x61\x75\u006c\u0074\x20\x54\x69\x74\u006c\u0065',
quantity: _3d494abb6abd,
price: _326968e1d525,
image: _1fd77bbf80a4,
line_key: '',
variant_id: _7b8bc3abd377,
product_id: _cbe627630570.id || '',
product_title: _cbe627630570.title || '',
variant_title: _ea2c3bf13158.title || '',
line_price: _326968e1d525 * _3d494abb6abd,
sku: _ea2c3bf13158.sku || '',
vendor: _cbe627630570.vendor || ''
}
]
};
_eabe822ebd18(_b92df18d4d75, _b5474812e795);
return;
}
const _6d17533bc84d =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _7c24e8b49db6 = await fetch(_6d17533bc84d + '\u0063\x61\x72\x74\x2e\x6a\x73', {
method: '\x47\u0045\x54',
credentials: '\x73\u0061\u006d\u0065\x2d\x6f\u0072\x69\x67\u0069\x6e',
headers: {
Accept: '\x61\x70\x70\x6c\u0069\u0063\x61\u0074\u0069\x6f\u006e\x2f\x6a\x73\x6f\x6e'
}
});
if (!_7c24e8b49db6.ok) {
const _e2d285e4e7f3 = await _7c24e8b49db6.text();
throw new Error('\x63\u0061\u0072\x74\u002e\u006a\u0073\x20\x66\x61\x69\u006c\x65\u0064\x3a\x20' + _e2d285e4e7f3.slice(0, 300));
}
const _cb55d65e888e = await _7c24e8b49db6.json();
if (!_cb55d65e888e || !Array.isArray(_cb55d65e888e.items) || _cb55d65e888e.items.length === 0) {
throw new Error('\x43\x61\u0072\x74\x20\u0069\x73\x20\u0065\x6d\x70\x74\u0079');
}
const _b5474812e795 = {
storeName: _35eea2c4306d,
store_name: _35eea2c4306d,
shop_name: _35eea2c4306d,
shop_domain: _346376858bf9,
shop_myshopify_domain: _89ed1ea27913,
cart_token: _cb55d65e888e.token || '',
currency: _d05ead839226(_cb55d65e888e),
item_count: _cb55d65e888e.item_count || 0,
subtotal_price: (_cb55d65e888e.items_subtotal_price || 0) / 100,
total_price: (_cb55d65e888e.total_price || 0) / 100,
shippingPrice: 0,
items: (_cb55d65e888e.items || []).map(function (_0ee11aa28b79) {
return {
title: _0ee11aa28b79.product_title || _0ee11aa28b79.title || '\u0050\u0072\u006f\u0064\u0075\u0063\u0074',
variant: _0ee11aa28b79.variant_title || '\x44\x65\u0066\u0061\x75\u006c\x74\u0020\u0054\x69\x74\x6c\x65',
quantity: _0ee11aa28b79.quantity || 1,
price: (_0ee11aa28b79.price || 0) / 100,
image: _0ee11aa28b79.image || '',
line_key: _0ee11aa28b79.key || '',
variant_id: _0ee11aa28b79.id || '',
product_id: _0ee11aa28b79.product_id || '',
product_title: _0ee11aa28b79.product_title || _0ee11aa28b79.title || '',
variant_title: _0ee11aa28b79.variant_title || '',
line_price: (_0ee11aa28b79.line_price || 0) / 100,
sku: _0ee11aa28b79.sku || '',
vendor: _0ee11aa28b79.vendor || ''
};
})
};
_eabe822ebd18(_b92df18d4d75, _b5474812e795);
} catch (_7f84c0512cac) {
console.error('\u0050\u0041\u0059\u0020\u0044\x45\u0042\x55\x47\u003a', _7f84c0512cac);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\x70\x69\x66\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_7f84c0512cac && _7f84c0512cac.message ? _7f84c0512cac.message : String(_7f84c0512cac))
);
_039f3b729156.disabled = false;
_039f3b729156.innerText = _59d45080c7dc;
}
},
true
);
})();
